import script from "./WebsiteFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteFooter.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteFooter.vue?vue&type=style&index=0&id=2b82411c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b82411c"]])

export default __exports__